import React, { useEffect, useRef, useState } from 'react';
import Select from 'react-select';
import { IoMdLocate } from "react-icons/io";
import { SiGooglemaps } from "react-icons/si";
import { motion } from 'framer-motion';
import { SubHeading } from '../../components';
import Map from '../../components/Map/Map';

import './FindUs.css'; // Import the CSS file for styling

const travelModeMapping = {
    DRIVING: 'Voiture',
    WALKING: 'Marche',
    BICYCLING: 'Vélo',
    TRANSIT: 'Métro'
};

const travelModeOptions = [
    { value: 'DRIVING', label: 'Voiture' },
    { value: 'WALKING', label: 'Marche' },
    { value: 'BICYCLING', label: 'Vélo' },
    { value: 'TRANSIT', label: 'Métro' }
];

const slideIn = {
    hidden: { opacity: 0, x: -100 },
    visible: { opacity: 1, x: 0 }
};

const FindUs = () => {
    const map = useRef(null);
    const userMarker = useRef(null);
    const directionsService = useRef(null);
    const directionsRenderer = useRef(null);
    const [selectedTravelMode, setSelectedTravelMode] = useState(travelModeOptions[0]);
    const [isVisible, setIsVisible] = useState(false);
    const [isGeolocated, setIsGeolocated] = useState(false);
    const [distance, setDistance] = useState('');
    const [duration, setDuration] = useState('');
    const infoRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        setIsVisible(true);
                    } else {
                        setIsVisible(false);
                    }
                });
            },
            { threshold: 0.1 }
        );

        if (infoRef.current) {
            observer.observe(infoRef.current);
        }

        return () => {
            if (infoRef.current) {
                observer.unobserve(infoRef.current);
            }
        };
    }, []);

    const handleGeolocate = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                const pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                };

                if (userMarker.current) {
                    userMarker.current.setPosition(pos);
                } else {
                    userMarker.current = new window.google.maps.Marker({
                        position: pos,
                        map: map.current,
                        title: 'Your Location',
                    });
                }

                map.current.setCenter(pos);
                setIsGeolocated(true);
            });
        }
    };

    const handleCalculateRoute = () => {
        if (!isGeolocated) {
            alert('Veuillez d\'abord cliquer sur le bouton de géolocalisation.');
            return;
        }

        if (userMarker.current) {
            const request = {
                origin: userMarker.current.getPosition(),
                destination: { lat: 48.8735493, lng: 2.3160211 },
                travelMode: selectedTravelMode.value,
            };

            directionsService.current.route(request, (result, status) => {
                if (status === 'OK') {
                    directionsRenderer.current.setDirections(result);
                    const route = result.routes[0].legs[0];
                    setDistance(route.distance.text);
                    setDuration(route.duration.text);
                }
            });
        }
    };

    const handleOpenGoogleMaps = () => {
        window.open(
            'https://www.google.fr/maps/place/Au+Mirod%C3%A9lice/@48.8735528,2.3134462,17z/data=!3m1!4b1!4m6!3m5!1s0x47e66f867d12760d:0xe4291d99abb41324!8m2!3d48.8735493!4d2.3160211!16s%2Fg%2F11jh2zhlpd?authuser=1&entry=ttu&g_ep=EgoyMDI2MDMyMy4xIKXMDSoASAFQAw%3D%3D',
            '_blank'
        );
    };

    return (
        <div className="app__bg app__wrapper section__padding" id="contact">
            <motion.div
                ref={infoRef}
                className="app__wrapper_info"
                initial="hidden"
                animate={isVisible ? "visible" : "hidden"}
                variants={slideIn}
                transition={{ duration: 0.8, ease: [0.6, -0.05, 0.01, 0.99] }}
            >
                <SubHeading title="Contact"/>
                <h1 className="headtext__cormorant" style={{marginBottom: '2rem'}}>Contact</h1>
                <div className="app__wrapper-content">
                    <p className="p__opensans">Adresse : 34 Rue de Miromesnil, Paris 75008</p>

                    <p className="p__cormorant" style={{color: '#DCCA87',marginTop: '3rem'}}>Heures d'ouverture</p>
                    <p className="p__opensans">Lundi - Vendredi : 10:30 - 19:30 </p>

                </div>
                <div className="app__wrapper_reviews">
                    <h1 className="headtext__cormorant" style={{marginTop: '3rem'}}>Itinéraire</h1>
                    <div className="geolocation-dropdown-container">
                        <button className="custom__button" onClick={handleGeolocate}>
                            <IoMdLocate size={20}/>
                        </button>
                        <button className="custom__button" onClick={handleOpenGoogleMaps}>
                            <SiGooglemaps size={20}/>
                        </button>
                        <Select
                            value={selectedTravelMode}
                            onChange={setSelectedTravelMode}
                            options={travelModeOptions}
                            className="travel-mode-select"
                        />
                    </div>
                    <button type="button" className="custom__button" style={{marginTop: '2rem'}}
                            onClick={handleCalculateRoute}>Calculer Trajet
                    </button>

                </div>
                {distance && duration && (
                    <div className="route-info">
                        <p className="p__opensans ">Distance: {distance}, Durée: {duration}</p>

                    </div>
                )}
            </motion.div>

            <div className="app__wrapper_img2">
                <Map mapRef={map} userMarkerRef={userMarker} directionsServiceRef={directionsService} directionsRendererRef={directionsRenderer} />
            </div>
        </div>
    );
};

export default FindUs;